<template>
  <a-config-provider :locale="locale">
    <transition appear
                appear-class="appear-class"
                appear-to-class="appear-to-class"
                appear-active-class="appear-active-class">
      <div id="app">

        <router-view v-if="show"/>
        <div v-else class="skipping">
          <a-spin tip="加载中..." size="large"/>
        </div>

      </div>
    </transition>
  </a-config-provider>
</template>
<script>

import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment from 'moment';
import 'moment/dist/locale/zh-cn';
moment.locale('zh-cn')

  export default {
    name: 'App',
    data () {
      return {
        locale: zhCN,
        show: false,
      }
    },
    // 动画效果
    beforeCreate () {
      // console.log('APP... BEFORE')
      this.show = false
    },
    created () {
      // console.log('APP...', this.show)
    },
    mounted () {
      // console.log('APP...', this.show)
      this.show = true
    },

  }
</script>

<style lang="less">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .skipping {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .appear-class {
    opacity: 0;
  }

  .appear-to-class {
    opacity: 1;
  }

  .appear-active-class {
    transition-duration: 2s;
  }
</style>
